angular
    .module('quattro.bmbo.email.model', [
        'quattro.core.model.prototype',
        'quattro.core.hpls_api_1',
    ])
    .factory('Email', function ($log, api, Model) {

        var prototype = Model.prototype;

        function getDefaultData() {
            return {
                // primary key
                mail: undefined,
                plan: undefined,
                forwards: [],
                aliases: [],
                inboxsave: true,
                active: true,
                capabilities: undefined,
                additional_cloud_quota: undefined,
                additional_mail_quota: undefined,
                plansavailable: undefined,
                possible_capabilities: undefined,
                require_reset_password: false
            };
        }


        var authorization = {
            read: 'all',
            create: ['admin', 'account'],
            update: {
                default: ['admin', 'account'],
                attributes: {}
            },
            remove: ['admin', 'account', 'domain'],
        };


        var scenarios = {
            read: [
                {
                    method: 'mail.get',
                    params: {
                        mail: {
                            primary_key: true,
                        },
                    },
                    results: {
                        mail: null,
                        type: null,
                        plan: null,
                        first_name: null,
                        last_name: null,
                        cell_phone: null,
                        inboxsave: null,
                        forwards: null,
                        aliases: null,
                        memo: null,
                        language: null,
                        active: null,
                        capabilities: null,
                        additional_cloud_quota: null,
                        additional_mail_quota: null,
                        plansavailable: null,
                        possible_capabilities: null,
                        require_reset_password: null,
                        allow_nets: null,
                        uid_extern: null,
                    }
                },
            ],
            create: [
                {
                    method: 'mail.add',
                    params: {
                        mail: {
                            primary_key: true,
                            filter: function (value, data) {
                                // `value` contains domain part
                                if (value.indexOf('@') !== -1) {
                                    return value;
                                }
                                // `value` contains only local part
                                return value + '@' + data.domain;
                            }
                        },
                        password: true,
                        plan: true,
                        first_name: true,
                        last_name: true,
                        cell_phone: null,
                        inboxsave: true,
                        forwards: true,
                        aliases: true,
                        memo: null,
                        language: null,
                        catchall: null,
                        create_own_context: null,
                        additional_cloud_quota: null,
                        additional_mail_quota: null,
                        require_reset_password: false,
                        uid_extern: null,
                    },
                }
            ],
            update: [
                {
                    method: 'mail.set',
                    params: {
                        mail: {
                            primary_key: true,
                        },
                        password: null,
                        plan: null,
                        first_name: null,
                        last_name: null,
                        cell_phone: null,
                        inboxsave: null,
                        forwards: null,
                        aliases: null,
                        memo: null,
                        language: null,
                        active: null,
                        additional_cloud_quota: null,
                        additional_mail_quota: null,
                        require_reset_password: null,
                        allow_nets: null,
                        uid_extern: null,
                    },
                },
                {
                    method: 'mail.capabilities.set',
                    params: {
                        mail: {
                            primary_key: true,
                        },
                        capabilities: {},
                    },
                },
            ],
            remove: [
                {
                    method: 'mail.del',
                    params: {
                        mail: {
                            primary_key: true,
                        },
                    },
                },
            ],
        };


        function query(domain) {
            var promise = api.single('mail.list', {
                domain: domain,
            });
            promise.then(null, function (error) {
                $log.error('mail.list', error.code, error.message);
            });
            return promise;
        }


        function Email(config, scenario) {
            this.scenario = scenario;
            var data = scenario === 'create' ? getDefaultData() : {};
            this.data = angular.merge(data, config);
            this.data.$validate = this.validate.bind(this);
        }

        // static
        Email.query = query;

        Email.prototype = angular.merge(new Model(), {
            scenarios: scenarios,
            authorization: authorization,
        });

        return Email;
    });
